const Menu = new function() {
    const menuButton = '.ss-nav-button';
    const menu = '.ss-nav';
    const menuLink = '.ss-nav li:not(.menu-item-has-children) a'
    const menuLinkHasChildren = '.ss-nav li.menu-item-has-children a';
    
    this.el = null
    this.menuButtons = []
    this.menuLinks = []
    this.menuLinksHasChildren = []

    let isOpen = false;
    this.currentSubMenu = null;

    this.init = () => {
        this.el = document.querySelector(menu);
        this.setTriggers()
        this.addLinkContentData();
    }

    this.addLinkContentData = () => {
        this.menuLinks.forEach(link => {
          const linkText = link.textContent.trim();
          link.setAttribute('data-content', linkText);
        });
    
        this.menuLinksHasChildren.forEach(link => {
          const linkText = link.textContent.trim();
          link.setAttribute('data-content', linkText);
        });
    }

    this.setTriggers = () => {
        this.menuButtons = []
        this.menuLinks = []
        this.menuLinksHasChildren = []

        document.querySelectorAll(menuButton).forEach(button => {
            if (!button.closest('.ss-search')) this.menuButtons.push(button)
        })
        
        document.querySelectorAll(menuLink).forEach(link => this.menuLinks.push(link))
        document.querySelectorAll(menuLinkHasChildren).forEach(linkH => this.menuLinksHasChildren.push(linkH))

        this.menuButtons.forEach(button => button.addEventListener('click', this.toggleMenu))
        this.menuLinks.forEach(link => link.addEventListener('click', this.closeMenu))
        this.menuLinksHasChildren.forEach(sublink => sublink.addEventListener('click', this.openSubMenu.bind(this)))

        // this.menuLinksHasChildren.forEach(sublink => {
        //     sublink.addEventListener('mouseenter', this.openSubMenu.bind(this));
        //     // sublink.addEventListener('mouseleave', this.closeSubMenu.bind(this));
        // });
    }

    this.toggleMenu = () => {
        isOpen ? this.closeMenu() : this.openMenu()
    }

    this.openSubMenu = (e) => {
        const clickedLink = e.target;
        const parentLi = clickedLink.parentNode;

        if (this.currentSubMenu && this.currentSubMenu !== parentLi) {
          this.currentSubMenu.classList.remove('submenu-opened');
        }
    
        parentLi.classList.toggle('submenu-opened');
        this.currentSubMenu = parentLi;
    }

    this.openMenu = () => {
        this.el.classList.add('show')
        isOpen = true
    }
    
    this.closeMenu = () => {
        this.removeSubMenuClass();
        this.el.classList.remove('show')
        isOpen = false
    }

    this.removeSubMenuClass = () => {
        this.menuLinksHasChildren.forEach(link => {
            link.parentNode.classList.remove('submenu-opened');
        });
    }

    this.closeSubMenu = (e) => {
        const leftLink = e.target;
        const leftParentLi = leftLink.parentNode;

        leftParentLi.classList.remove('submenu-opened');
        this.currentSubMenu = null;
    }
};

export default Menu;